uvex-lazy-gif {
  display: block;
  position: relative;
}
uvex-lazy-gif .preview {
  display: inline-block;
  cursor: pointer;
  position: relative;
  max-width: 100%;
}
uvex-lazy-gif .preview:not(.visible) {
  visibility: hidden;
  z-index: -1;
}
uvex-lazy-gif > picture {
  position: absolute;
  inset: 0;
}
uvex-lazy-gif svg {
  position: absolute;
  top: calc(50% - 3rem);
  left: calc(50% - 3rem);
  display: none;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 6rem;
  border: 5px solid #000;
  background-size: 3rem;
  border-radius: 50%;
  padding: 1.5rem;
  fill: #000;
}
uvex-lazy-gif picture + svg {
  display: inline-flex;
}